import type { ReactNode } from 'react';
import { PersonAddAlt1 as AddToCallIcon, PersonRemove as RemoveIcon } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';

interface WaitingRoomEntryActionButtonsProps {
  variant?: 'light' | 'dark';
  primaryLabel?: string;
  primaryIcon?: ReactNode;
  removeLabel?: string;
  onPrimaryAction?: () => void;
  onRemoveFromWaitingRoom?: () => void;
}

export function WaitingRoomEntryActionButtons({
  variant = 'light',
  primaryLabel = 'Add to current call',
  primaryIcon = <AddToCallIcon fontSize="small" />,
  removeLabel = 'Remove from waiting room',
  onPrimaryAction,
  onRemoveFromWaitingRoom,
}: WaitingRoomEntryActionButtonsProps) {
  const isDark = variant === 'dark';
  const secondaryButtonSx = {
    color: isDark ? 'grey.100' : 'text.secondary',
    borderColor: isDark ? 'rgba(255,255,255,0.24)' : 'divider',
    '&:hover': {
      borderColor: isDark ? 'rgba(255,255,255,0.42)' : 'text.secondary',
      bgcolor: isDark ? 'rgba(255,255,255,0.08)' : 'action.hover',
    },
  };

  return (
    <Stack spacing={0.75} sx={{ flexShrink: 0 }}>
      <Button
        size="small"
        variant="contained"
        startIcon={primaryIcon}
        disabled={!onPrimaryAction}
        onClick={onPrimaryAction}
        sx={{ justifyContent: 'flex-start', textTransform: 'none', fontWeight: 800 }}
      >
        {primaryLabel}
      </Button>

      <Button
        size="small"
        variant="outlined"
        startIcon={<RemoveIcon fontSize="small" />}
        disabled={!onRemoveFromWaitingRoom}
        onClick={onRemoveFromWaitingRoom}
        sx={{ justifyContent: 'flex-start', textTransform: 'none', ...secondaryButtonSx }}
      >
        {removeLabel}
      </Button>
    </Stack>
  );
}
